<i2a-external-delegates [title]="'profile.provider.microsoft.sharePoint.external' | i18next"
    [subTitle]="" [delegates]="delegatesWithAlerts" [isAlert]="isAlert"
    [hasAlert]="hasAlert" [hasAlertRecentlyClosed]="hasAlertRecentlyClosed" (onWarnClick)="warnClick($event)"
    [viewWarnButton]="viewWarnButton" [resourceProfile]="resourceProfile">
</i2a-external-delegates>
